import React from 'react';
import { SvgIcon } from '@mui/material';

const Favorite = (props) => (
  <SvgIcon {...props}>
    <svg
      viewBox="0 0 20 20"
      fill="#000"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Vector"
        d="M11.1249 16.7755C10.4916 17.3505 9.51655 17.3505 8.88322 16.7672L8.79155 16.6839C4.41655 12.7255 1.55822 10.1339 1.66655 6.90055C1.71655 5.48388 2.44155 4.12555 3.61655 3.32555C5.81655 1.82555 8.53322 2.52555 9.99988 4.24221C11.4665 2.52555 14.1832 1.81721 16.3832 3.32555C17.5582 4.12555 18.2832 5.48388 18.3332 6.90055C18.4499 10.1339 15.5832 12.7255 11.2082 16.7005L11.1249 16.7755Z"
        fill={props.fill}
      />
    </svg>
  </SvgIcon>
);

export default Favorite;
